import PropTypes from 'prop-types'

/*
EXAMPLE:
{
  filemime: "application/vnd.xfdl"
  filename: "b73c6a32-5412-32eb-ad75-8a30c20d689f.sql"
  id: "11e9008b030acfb0b1c96f6aaf27dcb1"
  processed_at: 1513647020
}
*/

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
  filemime: PropTypes.string,
  filename: PropTypes.string,
  processed_at: PropTypes.number,
})
